/**
 * Utilitário centralizado para obter URLs da API no app customer
 * Retorna estritamente o valor configurado nas variáveis de ambiente (.env)
 */

export function getCustomerApiBaseURL(): string {
  return import.meta.env.VITE_CUSTOMER_API_URL || '/customer';
}

export function getApiBaseURL(): string {
  return import.meta.env.VITE_API_URL || '/admin';
}

/**
 * Retorna o host raiz da API (ex: http://api.sstlocal, https://api.staging.sstexames.com.br, https://api.sstexames.com.br)
 * derivado da variável VITE_CUSTOMER_API_URL / VITE_API_URL ou do hostname do navegador
 */
export function getApiHostURL(): string {
  const envUrl = import.meta.env.VITE_CUSTOMER_API_URL || import.meta.env.VITE_API_URL;
  if (envUrl && envUrl.startsWith('http')) {
    return envUrl.replace(/\/(customer|admin)\/?$/, '');
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.includes('staging')) {
      return 'https://api.staging.sstexames.com.br';
    }
    if (host.includes('sstlocal')) {
      return 'http://api.sstlocal';
    }
    if (host.includes('sstexames.com.br')) {
      return 'https://api.sstexames.com.br';
    }
  }
  return 'http://api.sstlocal';
}

/**
 * Retorna o link absoluto para a documentação interativa Swagger (/api/docs)
 * apontando estritamente para o ambiente correspondente (.env)
 */
export function getSwaggerURL(): string {
  return `${getApiHostURL()}/api/docs`;
}

/**
 * Retorna o endpoint base das APIs públicas de integração REST (/api/v1)
 */
export function getIntegrationApiBaseURL(): string {
  return `${getApiHostURL()}/api/v1`;
}

export function getUploadsBaseURL(): string {
  return `${getApiBaseURL()}/uploads`;
}
